import React, { useId } from 'react';
import { UIComponent } from '@/components/core/components';
import ContentLoader from 'react-content-loader';
import clsx from 'clsx';
import theme from '@/components/core/theme';
import * as styles from './feed-loading.styles';

const FeedLoading: UIComponent = ({ className, ...props }) => {
  const id = useId();
  return (
    <div className={clsx(styles.root, className)} {...props}>
      <ContentLoader viewBox="0 0 440 680" uniqueKey={`bg-${id}`} className={clsx(styles.bg)}>
        {/* Only SVG shapes */}
        <rect x="0" y="0" width="480" height="680" />
      </ContentLoader>
      <ContentLoader
        uniqueKey={`fg-${id}`}
        viewBox="0 0 440 680"
        backgroundColor={theme.colors.peoople['gris-claro']}
        foregroundColor={theme.colors.peoople['gris-medio']}
        className={clsx(styles.bg)}
      >
        <rect x="20" y="30" width="300" height="8" />
        <rect x="20" y="54" width="200" height="8" />
        <circle cx="400" cy="40" r="20" />
        <circle cx="40" cy="120" r="16" />
        <rect x="60" y="110" width="100" height="8" />
        <rect x="60" y="125" width="100" height="8" />
        <rect x="120" y="240" width="200" height="200" />

        <rect x="20" y="620" width="200" height="8" />
        <rect x="20" y="640" width="300" height="8" />
      </ContentLoader>
    </div>
  );
};

export default FeedLoading;
